



































import Vue from 'vue';

import { Dialog } from '@/services/UI';

export default Vue.extend({
    props: {
        dialog: {
            type: Object as () => Dialog,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        headerColor: {
            type: String,
            default: 'primary',
        },
        color: {
            type: String,
            default: null,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
        dark: {
            type: Boolean,
            default: false,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close() {
            if (!this.persistent) {
                this.$ui.closeDialog(this.dialog.id);
            }
        },
    },
});
